'use client';

import React, { useState, useCallback, useEffect } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import FalseSolutions from "@/components/landing/FalseSolutions";
import Solution from "@/components/landing/Solution";
import Benefits from "@/components/landing/Benefits";
import Pricing from "@/components/landing/Pricing";
import Guarantee from "@/components/landing/Guarantee";
import Faq from "@/components/landing/Faq";
import CtaSection from "@/components/landing/CtaSection";
import Footer from "@/components/landing/Footer";
import InteractiveChat from "@/components/landing/InteractiveChat";

const dynamicIntroMessagesForProblem = [
    "Mais de 120 mensagens/dia? (clique aqui)",
    "70% de dúvidas repetitivas? (clique aqui)",
    "Dê a atenção que seus pacientes merecem (clique aqui)",
    "Equipe sobrecarregada? (clique aqui)",
];

const dynamicIntroMessagesForFalseSolutions = [
    "Contratar mais secretárias não resolve? (clique aqui)",
    "Sistemas hospitalares são muito caros? (clique aqui)",
    "Chatbots genéricos te preocupam? (clique aqui)",
    "Cansado de responder tudo sozinho? (clique aqui)",
];

const dynamicIntroMessagesForPricing = [
    "Vamos trabalhar juntos? (clique aqui)"
];

const chatMessagesForPricing = [
    "Serei um ótimo assistente!",
    "Vamos encontrar o plano ideal para você?"
];

export default function Home() {
  const [isBot, setIsBot] = useState(false);
  const [isHeroAnimationDone, setIsHeroAnimationDone] = useState(false);

  React.useEffect(() => {
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const bot = /bot|googlebot|crawler|spider|crawling/i.test(userAgent);
    setIsBot(bot);
    if (bot) {
        setIsHeroAnimationDone(true);
    }
  }, []);

  const handleHeroAnimationComplete = useCallback(() => {
    setIsHeroAnimationDone(true);
  }, []);

  return (
    <div className="flex min-h-screen w-full flex-col">
      <Header />
      <main className="flex-1">
        <Hero isBot={isBot} onAnimationComplete={handleHeroAnimationComplete} />
        <Problem isBot={isBot}/>
        <FalseSolutions isBot={isBot} />
        <Solution isBot={isBot} />
        <Benefits isBot={isBot} />
        <Pricing isBot={isBot} />
        <Guarantee isBot={isBot} />
        <Faq />
        <CtaSection />
      </main>
      <Footer />
      <InteractiveChat
          introMessages={dynamicIntroMessagesForProblem}
          scrollTriggerId="problem"
      />
      <InteractiveChat
          introMessages={dynamicIntroMessagesForFalseSolutions}
          scrollTriggerId="false-solutions"
      />
       <InteractiveChat
          introMessages={dynamicIntroMessagesForPricing}
          chatMessages={chatMessagesForPricing}
          scrollTriggerId="pricing"
      />
    </div>
  );
}
